import React from 'react'
import { PresetConfigLoader } from '../../../views/Setup/AIFeaturePresets/PresetConfig/Common/PresetConfigLoader'
import { useMeetingTemplateEffectiveInputParameters, useTeamMembersFilter } from '../hooks'
import { MeetingTemplateInputParametersHierarchyConfigComponentProps } from '../model'
import { InviteTeamMembers } from '../../../views/Setup/AIFeaturePresets/PresetConfig/Common/InviteTeamMembers'
import { TeamMemberPresetConfigFormBody } from './TeamMemberPresetConfigFormBody'

export const MeetingTemplateTeamMemberTemplateInputParameterConfigForm: React.FC<MeetingTemplateInputParametersHierarchyConfigComponentProps> = ({
  type,
  typeId,
  inputParametersSchema,
  defaultInputParameters,
  meetingTemplateId,
  showCustomizationSetting,
  onHide,
  ipHierarchyEnabled,
}) => {
  const { userFilterValues, selectedUserFilterOption, setSelectedUserFilterOption, hasTeamMembers, teamMembersLoading } = useTeamMembersFilter()

  const { inputParameters, parentInputParameters, updateLoading, updateInputParameters, isCustomized } = useMeetingTemplateEffectiveInputParameters(
    type,
    typeId,
    defaultInputParameters,
    selectedUserFilterOption?.id,
    meetingTemplateId,
  )

  if (teamMembersLoading || !inputParameters || !parentInputParameters) {
    return <PresetConfigLoader />
  }

  if (!hasTeamMembers) {
    return <InviteTeamMembers />
  }

  return (
    <TeamMemberPresetConfigFormBody
      type={type}
      typeId={typeId}
      inputParametersSchema={inputParametersSchema}
      inputParameters={{ example_1: '', example_2: '', template: inputParameters.template }}
      defaultInputParameters={{ example_1: '', example_2: '', template: defaultInputParameters?.template ?? '' }}
      parentInputParameters={{ example_1: '', example_2: '', template: parentInputParameters.template }}
      isCustomized={isCustomized}
      showCustomizationSetting={showCustomizationSetting}
      onSave={updateInputParameters}
      onHide={onHide}
      updateLoading={updateLoading}
      userFilterValues={userFilterValues}
      selectedUserFilterOption={selectedUserFilterOption}
      setSelectedUserFilterOption={setSelectedUserFilterOption}
      ipHierarchyEnabled={ipHierarchyEnabled}
    />
  )
}
